module.exports = __webpack_public_path__ + "img/story-1.5df36f53.jpg";